/* eslint-disable react/jsx-props-no-spreading */
import { useTranslation } from 'react-i18next';
import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { DataLine, NameLabel } from 'components/elements';
import PronounSelect from './PronounSelect';

function PronounSelectControl({ required, isEditMode, name, control, rules }) {
  const { t } = useTranslation('labels');

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { ref, value, ...restField }, fieldState: { error } }) =>
        isEditMode ? (
          <PronounSelect pronoun={value} error={!!error} required={required} helperText={error ? error.message : null} {...restField} />
        ) : (
          <DataLine label={t('personal_pronoun')} body={<NameLabel personalPronoun={value} />} />
        )
      }
    />
  );
}

PronounSelectControl.propTypes = {
  required: PropTypes.bool,
  isEditMode: PropTypes.bool,
  name: PropTypes.string.isRequired,
  control: PropTypes.objectOf(PropTypes.any).isRequired,
  pronoun: PropTypes.string,
  rules: PropTypes.shape({}),
};

PronounSelectControl.defaultProps = {
  required: false,
  isEditMode: false,
  pronoun: '',
  rules: {},
};

export default PronounSelectControl;
